import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '../../../base/ui/components/web/Button';
import Checkbox from '../../../base/ui/components/web/Checkbox';
import { BUTTON_TYPES } from '../../../base/ui/constants';
import { isSubmitAnswerDisabled } from '../../functions';
import AbstractPollAnswer from '../AbstractPollAnswer';
const useStyles = makeStyles()((theme) => {
    return {
        buttonMargin: {
            marginRight: theme.spacing(2)
        }
    };
});
const PollAnswer = ({ creatorName, checkBoxStates, poll, setCheckbox, skipAnswer, skipChangeVote, submitAnswer, t }) => {
    const { changingVote } = poll;
    const { classes: styles } = useStyles();
    return (React.createElement("div", { className: 'poll-answer' },
        React.createElement("div", { className: 'poll-header' },
            React.createElement("div", { className: 'poll-question' },
                React.createElement("span", null, poll.question)),
            React.createElement("div", { className: 'poll-creator' }, t('polls.by', { name: creatorName }))),
        React.createElement("ol", { className: 'poll-answer-list' }, poll.answers.map((answer, index) => (React.createElement("li", { className: 'poll-answer-container', key: index },
            React.createElement(Checkbox, { checked: checkBoxStates[index], key: index, label: answer.name, 
                // eslint-disable-next-line react/jsx-no-bind
                onChange: ev => setCheckbox(index, ev.target.checked) }))))),
        React.createElement("div", { className: 'poll-footer poll-answer-footer' },
            React.createElement(Button, { accessibilityLabel: t('polls.answer.skip'), className: styles.buttonMargin, fullWidth: true, labelKey: 'polls.answer.skip', onClick: changingVote ? skipChangeVote : skipAnswer, type: BUTTON_TYPES.SECONDARY }),
            React.createElement(Button, { accessibilityLabel: t('polls.answer.submit'), disabled: isSubmitAnswerDisabled(checkBoxStates), fullWidth: true, labelKey: 'polls.answer.submit', onClick: submitAnswer }))));
};
/*
 * We apply AbstractPollAnswer to fill in the AbstractProps common
 * to both the web and native implementations.
 */
// eslint-disable-next-line new-cap
export default AbstractPollAnswer(PollAnswer);
